import { defineStore } from 'pinia'
import { useUserStore } from "@/stores/UserStore"

export const useGeneralSearch = defineStore('GeneralSearchEngine', () => {

  const isLoading = ref(false)
  const generalResults = ref([])
  const term = ref('')
  const message = ref('')
  const error = ref('')
  const searchHistory = ref([])
  const userStore = useUserStore()

  // Get user-specific storage key
  const getStorageKey = () => {
    const salonerId = userStore.currentUser?.salonerId || ''
    //
    return `searchHistory_${salonerId}`
  }

  // Load search history from localStorage
  // function loadSearchHistory() {
  //   try {
  //     searchHistory.value = JSON.parse(localStorage.getItem('searchHistory')) || []
  //   } catch (error) {
  //     console.error('Error loading search history:', error)
  //     searchHistory.value = []
  //   }
  // }

  const loadSearchHistory = () => {
    try {
      searchHistory.value = JSON.parse(localStorage.getItem(getStorageKey())) || []
    } catch (error) {
      console.error('Error loading search history:', error)
      searchHistory.value = []
    }
  }


  // Save selected item to search history
  const saveSelectedItemToHistory = (item) => {
    if (!item || !item.label) return

    // Use the in-memory history reference instead of reading from localStorage again
    const filteredHistory = [...searchHistory.value].filter(
      historyItem => historyItem.identifier !== item.identifier
    )

    // Add new item at beginning
    filteredHistory.unshift(item)

    // Limit to 10 items
    const limitedHistory = filteredHistory.slice(0, 10)

    // Update the reactive ref
    searchHistory.value = limitedHistory

    // Save to localStorage
    // localStorage.setItem('searchHistory', JSON.stringify(limitedHistory))
    localStorage.setItem(getStorageKey(), JSON.stringify(limitedHistory))
  }

  // Remove a single item from search history by identifier
  const removeFromHistory = (identifier) => {
    try {
      searchHistory.value = searchHistory.value.filter(
        item => item.identifier !== identifier,
      )
      localStorage.setItem(getStorageKey(), JSON.stringify(searchHistory.value))
    } catch (err) {
      //
    }
  }

  // Clear search history
  const clearSearchHistory = () => {
    searchHistory.value = []
    // localStorage.removeItem('searchHistory')
    localStorage.removeItem(getStorageKey())
  }

  const getResults = async (searchTerm) =>  {
    if (!searchTerm || searchTerm.trim() === '') {
      generalResults.value = []

      return { success: false }
    }

    term.value = searchTerm
    isLoading.value = true

    try {
      const queryParams = new URLSearchParams()
      queryParams.append('term', searchTerm)

      const response = await $backend(`/search/index?${queryParams.toString()}`, {
        method: 'GET',
      })

      if(response.success) {
        generalResults.value = response.data || []
        message.value = response.message || ''
        // Removed saveToSearchHistory call - we only want to save clicked items
      } else {
        error.value = response.message || 'Search failed'
        generalResults.value = []
      }

      return response
    } catch (err) {
      error.value = err.message || 'An error occurred during search'
      generalResults.value = []

      return { success: false, message: error.value }
    } finally {
      isLoading.value = false
    }
  }

  loadSearchHistory()

  return {
    isLoading,
    generalResults,
    term,
    message,
    error,
    getResults,
    searchHistory,
    clearSearchHistory,
    saveSelectedItemToHistory,
    removeFromHistory,
  }
})
